import { useEffect } from 'react'
import { NextSeo } from 'next-seo'
import { Container } from '@/features/global/components/Layout/Container'
import { useBreadcrumb } from '@/hooks/useBreadcrumb'
import { BookmarkResponse } from '@/types/bookmark'
import { GetFavoriteResponse } from '@/types/favorite'
import { SummaryDetailResponse } from '@/types/summary'
import { Reason, UserInfo } from '@/types/user'
import { Header, HeaderSp, Info, InfoSp, SummaryBody } from '.'
import { SchoolSummaryStatus } from '@/types/school'
import { SummaryDetailForBooksellerPage } from './SummaryDetailForBooksellerPage'
import { postUserHistory } from '@/api/user'

interface Props {
  userInfo: UserInfo
  summaryDetail: SummaryDetailResponse
  bookmarkResponse?: BookmarkResponse
  favoriteResponse?: GetFavoriteResponse
  schoolStatus?: SchoolSummaryStatus
  readThisMonth?: number
  code?: string
}

export const SummaryDetailPage: React.FC<Props> = ({
  userInfo,
  summaryDetail,
  bookmarkResponse = null,
  favoriteResponse = null,
  schoolStatus = null,
  readThisMonth = 0,
  code = '',
}) => {
  // Booksellerから遷移した場合はそれ用の表示にする
  if (code) {
    return <SummaryDetailForBooksellerPage summaryDetail={summaryDetail} />
  }

  useBreadcrumb([
    {
      name: 'すべての要約',
      url: '/summary/list',
    },
    { name: summaryDetail.summary.title },
  ])

  useEffect(() => {
    if (summaryDetail.reason === Reason.READABLE) {
      postUserHistory(summaryDetail.summary.id)
    }
  })
  return (
    <>
      <Header
        userInfo={userInfo}
        summary={summaryDetail.summary}
        bookmark={bookmarkResponse?.result}
        favorite={favoriteResponse?.favorite}
      />
      <HeaderSp
        userInfo={userInfo}
        summary={summaryDetail.summary}
        bookmark={bookmarkResponse?.result}
        favorite={favoriteResponse?.favorite}
      />
      <Info
        summary={summaryDetail.summary}
        reason={summaryDetail.reason}
        courseId={userInfo?.course?.id}
        readThisMonth={readThisMonth}
      />
      <InfoSp summary={summaryDetail.summary} reason={summaryDetail.reason} />
      <Container sidebar={{ pc: true, sp: true }}>
        <NextSeo
          title={`${summaryDetail.summary.title} ${
            summaryDetail.summary.subtitle
              ? `/ ${summaryDetail.summary.subtitle} `
              : ''
          } | 本の要約サイト flier(フライヤー)`}
          description={summaryDetail.summary.review.slice(0, 100)}
          robotsProps={{
            noarchive: true,
          }}
          openGraph={{
            images: [
              {
                url: `${process.env.IMG_SERVER}/summary/${summaryDetail.summary.id}_ogp.jpg`,
                width: 1200,
                height: 630,
              },
            ],
          }}
          twitter={{
            cardType: 'summary_large_image',
          }}
        />
        <SummaryBody
          userInfo={userInfo}
          summary={summaryDetail.summary}
          recommends={summaryDetail.recommends}
          reason={summaryDetail.reason}
          schoolStatus={schoolStatus}
          readThisMonth={readThisMonth}
        />
      </Container>
    </>
  )
}
